module.exports = __webpack_public_path__ + "fonts/BebasNeueBold.1e99b044.ttf";